// src/components/AuthHeader.tsx
// ヘッダ右側に user 表示 + ログアウト + 管理画面リンク

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { authApi } from "../lib/auth-api";

export function AuthHeader() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["auth", "me"],
    queryFn: authApi.me,
    retry: false,
    staleTime: 30_000,
  });

  if (!data) return null;
  const u = data.user;
  // 認証 OFF 時 (AUTH_DISABLED=true) は ログアウト UI を出さない
  if (u.email === "auth-disabled@local") return null;

  const onLogout = async () => {
    try { await authApi.logout(); } catch { /* ignore */ }
    qc.clear();
    navigate("/login");
  };

  return (
    <div className="flex items-center gap-2 text-xs">
      {(u.beta || u.is_admin) && (
        <>
          {/* 新GPは2026-08-25に正式昇格。開発版への入口は未リリースタブだけ。 */}
          <Link to="/beta" className="px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 hover:bg-amber-200 font-medium" title="開発版(タブ): リリース前タブ (入院実績(医師別)・明細分析・データ辞書 など)">🧪 開発版(タブ)</Link>
          <span className="text-slate-300">|</span>
        </>
      )}
      <Link to="/m" className="text-blue-700 hover:underline" title="モバイル版 (入院実績 / 手術 / 入院経路 / PL)">📱 モバイル版</Link>
      <span className="text-slate-300">|</span>
      {u.is_admin && (
        <>
          <Link to="/admin/users" className="text-blue-700 hover:underline">ユーザ管理</Link>
          <span className="text-slate-300">|</span>
          <Link to="/admin/events" className="text-blue-700 hover:underline">監査ログ</Link>
          <span className="text-slate-300">|</span>
        </>
      )}
      <span className="text-slate-600">{u.email}</span>
      <button
        type="button" onClick={onLogout}
        className="ml-1 px-2 py-0.5 text-xs border border-slate-300 rounded hover:bg-slate-50"
      >
        ログアウト
      </button>
    </div>
  );
}
